import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appPreventSpaceDirective]',
})
export class PreventSpaceDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }
}
